import React, {Fragment, useRef} from 'react';
import {ChannelContentProps} from '@app/channels/channel-content';
import {ChannelHeader} from '@app/channels/channel-header/channel-header';
import {ChannelContentGridItem} from '@app/channels/content-grid/channel-content-grid-item';
import {useCarousel} from '@app/channels/carousel/use-carousel';
import clsx from 'clsx';
import {ContentGridProps} from '@app/channels/content-grid/content-grid-layout';
import {IconButton} from '@common/ui/buttons/icon-button';
import {KeyboardArrowLeftIcon} from '@common/icons/material/KeyboardArrowLeft';
import {KeyboardArrowRightIcon} from '@common/icons/material/KeyboardArrowRight';
import {Container} from 'react-bootstrap';
// Swiper
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Navigation} from 'swiper/modules';
import {Link, useParams} from 'react-router-dom';
import {Trans} from '@common/i18n/trans';
import {useThemeSelector} from '@common/ui/themes/theme-selector-context';
import {useSelectedLocale} from '@common/i18n/selected-locale';
import { ChannelContentModel } from '@app/admin/channels/channel-content-config';

const modules = [Autoplay, Navigation];

interface Props extends ChannelContentProps {
  variant?: ContentGridProps['variant'];
}
export function ChannelContentCarousel(props: Props) {
  const {channel, variant} = props;
  const {
    scrollContainerRef,
    canScrollForward,
    canScrollBackward,
    scrollToPreviousPage,
    scrollToNextPage,
    containerClassName,
    itemClassName,
  } = useCarousel();

  const gridClassName =
    variant === 'landscape'
      ? 'content-grid-landscape'
      : 'content-grid-portrait';

  const slider = useRef<HTMLDivElement>(null);
  const {selectedTheme} = useThemeSelector();
  const {locale} = useSelectedLocale();

  const initSwiper = (swiper: any) => {
    addCustomClassToVisibleSlides(swiper);
  };

  const addCustomClassToVisibleSlides = (swiper: any) => {
    if (slider.current) {
      if (swiper) {
        slider.current
          .querySelectorAll('.swiper-slide')
          .forEach(separateSlide => separateSlide.classList.remove('last'));

        const swiperSlide = slider.current.querySelectorAll(
          '.swiper-slide-visible',
        );

        const lastVisibleSlide = swiperSlide[swiperSlide.length - 1];

        setTimeout(() => {
          if (lastVisibleSlide) {
            lastVisibleSlide.classList.add('swiper-active', 'last');
          }
        }, 0);
      }
    }
  };

  const shuffle = (array: any) => {
    let currentIndex = array.length,
      randomIndex;
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }
    return array;
  };

  const indexes = [...Array(channel.content?.data.length).keys()];
  const shuffledIndexes = shuffle([...indexes]);
  const selectedIndexes = shuffledIndexes.slice(0, 10);

  const {restriction: urlParam} = useParams();
  if (channel.config.hideTitle) {
    return null;
  }

  const link =
    channel.config.restriction && urlParam
      ? `/${channel.slug}/${urlParam}`
      : `/${channel.slug}`;

  return (
    <>
      {/* {' '}
      <div>
        <ChannelHeader
          {...props}
          actions={
            <Fragment>
              <IconButton
                disabled={!canScrollBackward}
                onClick={() => scrollToPreviousPage()}
                aria-label="Previous page"
              >
                <KeyboardArrowLeftIcon />
              </IconButton>
              <IconButton
                disabled={!canScrollForward}
                onClick={() => scrollToNextPage()}
                aria-label="Next page"
              >
                <KeyboardArrowRightIcon />
              </IconButton>
            </Fragment>
          }
        />
        <div
          ref={scrollContainerRef}
          className={clsx(containerClassName, gridClassName)}
        >
          {channel.content?.data.map(item => (
            <div
              className={itemClassName}
              key={`${item.id}-${item.model_type}`}
            >
              <ChannelContentGridItem item={item} variant={variant} />
            </div>
          ))}
        </div>
      </div> */}
      <div className="card-style-slider overflow-hidden">
        <Container fluid>
          <div className={`card-style-slider overflow-hidden`} ref={slider}>
            <div
              className={`d-flex align-items-center justify-content-between px-md-3 mb-4 px-1`}
            >
              <h4
                className={`main-title text-capitalize mb-0 text-sm md:text-2xl ${!selectedTheme.is_dark && 'text-black'}`}
              >
                <Trans message={channel.name} />
              </h4>
              <Link
                to={link}
                className="iq-view-all text-decoration-none !text-xs !font-bold text-primary md:!text-lg"
              >
                <Trans message="View All" />
              </Link>
            </div>
            <Swiper
              className={`swiper swiper-card swiper-initialized swiper-horizontal swiper-pointer-events swiper-watch-progress swiper-backface-hidden position-relative`}
              // dir={locale.language === "fa" ? "rtl" : "ltr"}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                  spaceBetween: 4,
                },
                576: {
                  slidesPerView: 2,
                  spaceBetween: 4,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 4,
                },
                1025: {
                  slidesPerView: 4,
                  spaceBetween: 4,
                },
                1500: {
                  slidesPerView: 6,
                  spaceBetween: 4,
                },
              }}
              loop
              watchSlidesProgress
              // navigation={{
              //   prevEl: '.swiper-button-prev',
              //   nextEl: '.swiper-button-next',
              // }}
              navigation={{
                prevEl: '.swiper-banner-button-prev',
                nextEl: '.swiper-banner-button-next',
              }}
              onSwiper={initSwiper}
              onSlideChange={initSwiper}
              modules={modules}
            >
              {
                //@ts-expect-error
                selectedIndexes.map((index) => (
                  <SwiperSlide tag="li" key={index + generateUUID() + 'slider'}>
                    <ChannelContentGridItem item={channel.content?.data[index] as ChannelContentModel} variant={variant} />
                  </SwiperSlide>
                ))
              }
              {/* <div className="swiper-button swiper-button-next"></div>
              <div className="swiper-button swiper-button-prev"></div> */}
              <div
                className="swiper-banner-button-prev swiper-nav hidden md:block"
                id="swiper-banner-button-prev"
              >
                <i></i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 44 44"
                  width="44"
                  height="44"
                  fill="none"
                  stroke="currentColor"
                >
                  <circle r="20" cy="22" cx="22"></circle>
                </svg>
              </div>
              <div
                className="swiper-banner-button-next swiper-nav hidden md:block"
                id="swiper-banner-button-next"
              >
                <i></i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 44 44"
                  width="44"
                  height="44"
                  fill="none"
                  stroke="currentColor"
                >
                  <circle r="20" cy="22" cx="22"></circle>
                </svg>
              </div>
            </Swiper>
          </div>
        </Container>
      </div>
    </>
  );
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
